import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export const ContentInterceptor: HttpInterceptorFn = (
    req: HttpRequest<any>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const urlToMatch = environment.api.cms.wp;

    if (req.url.startsWith(urlToMatch)) {
        const clone = req.clone({
            setParams: {
                per_page: '100', // max wordpress paging size without modifying server/theme. filtering REST API response data is not supported natively.
                acf_format: 'standard', // format advanced custom fields using the standard format, which includes full thumbnail URLs instead of just IDs for media.
            },
        });
        console.debug('[Interceptors][ContentInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(req);
    }
};
